const FORTY_FIVE_MINUTES = 45 * 60 * 1000;
const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

export {FORTY_FIVE_MINUTES, TWENTY_FOUR_HOURS};
